export function parseLeadsCookie() {
    let cookie = getCookie("Leads");
    var parsedValues = null;

    if (cookie) {
        parsedValues = {};
        for (var t of cookie.split('|')) {
            let kvp = t.split('=');
            let keyLowerFirstChar = kvp[0].charAt(0).toLowerCase() + kvp[0].substr(1);

            parsedValues[keyLowerFirstChar] = kvp[1];
        }
    }

    return parsedValues;
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

